import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
// import { GoogleLogin } from "react-google-login";
// import FacebookLogin from "react-facebook-login";
import $ from 'jquery';
import { get } from 'lodash';
import { Multiselect } from 'multiselect-react-dropdown';
import { toast } from "react-toastify";
import CONSTANT from "../../constants/constant";
import UtilService from "../utils/utils";
import PasswordField from "../view/PasswordField";
import PasswordStrengthView from "../view/PasswordStrengthView";
import ValidationMessage from '../view/ValidationMessage';
import { addPlayerRegistration, getClubList, resetFormData, emailVerification, otpVerification } from './playerAction';
import { NavLink } from "react-router-dom/cjs/react-router-dom.min";

const playerInitialValue = {
  firstName: "",
  middleName: "",
  lastName: "",
  email: "",
  countryCode: "US,+1",
  mobile: "",
  pin: "",
  password: "",
  cardinfo: "",
  currency: "",
  confirmPassword: "",
  passwordMatch: true,
  emailVerified: false,
  clubs: [],
  isEulaAccepted: false,
  isOtpSending: false,
  isReferee : false

}
const playerValidationMessage = {
  firstName: "First Name is required",
  lastName: "Last Name is required",
  email: "Email is required in correct format",
  mobile: "Mobile number is required",
  password: "Password policy does not match ",
  confirmPassword: "Passwords Don't Match",
  pin: "User pin is required in correct format",
  isEulaAccepted: "Please accept the terms and conditions."

}
let res = '';

class registrationPage extends Component {
  constructor(props) {
    super(props);
    this.multiselectRef = React.createRef();
    this.fiveMinutes = 5 * 60 * 1000; // 5 minutes in milliseconds
    this.state = {
      currenciesData: [],
      playerData: playerInitialValue,
      error: {},
      hidden: true,
      showOtp: false,
      clubListData: [],
      otp: "",
      isdisabled: true,
      timeRemaining: this.fiveMinutes,
      timerRunning: false,
      isResendOtp: false
    };
    this.passwordType = null;

  }
  async componentDidMount() {
    try {
      let response = await UtilService.getCurrencyList();
      if (response && response.countries) {
        this.setState({
          currenciesData: response.countries,
        });
      } else {
        toast.error(response?.message);
      }
      await this.props.dispatch(getClubList())

      const clubListData = get(
        this.props,
        "apiReducer.clubNameListApiSuccesData",
        null
      );
      let clubListDetails = clubListData ? JSON.parse(clubListData) : [];
      this.setState({ clubListData: clubListDetails })
      this.timerInterval = null;
    } catch (error) {
      console.error(error);
    }
  }
  // responseGoogle = (response) => {
  //   console.log("tttttt",response.tokenId);//googleRegistration
  //   const obj = {
  //     idTokenString:response.tokenId
  //   }
  //   // this.props.dispatch(googleRegistration( obj))
  // };
  // responseFacebook = (response) => {
  //   console.log(response);
  // };

  componentWillUnmount() {
    clearInterval(this.timerInterval);
  }



  updateTimer = () => {
    const { timerRunning, timeRemaining } = this.state;
    const startTime = Date.now();

    this.timerInterval = setInterval(() => {
      const currentTime = Date.now();
      const elapsedTime = currentTime - startTime;
      const remainingTime = this.fiveMinutes - elapsedTime;

      if (remainingTime <= 0) {
        clearInterval(this.timerInterval);
        this.setState({
          timeRemaining: 0,
          timerRunning: false,
        });
        // alert("OTP has been expired. Please try again");
        this.setState({ showOtp: false, isResendOtp: true });
      } else {
        this.setState({
          timeRemaining: remainingTime,
        });
      }
    }, 1000);
  };

  startTimer = () => {
    this.setState({
      timerRunning: true,
    });
    this.updateTimer();
  };

  resetTimer = () => {
    clearInterval(this.timerInterval);
    this.setState({
      timeRemaining: this.fiveMinutes,
      timerRunning: false,
    });
  };

  formatTime = (milliseconds) => {
    const minutes = Math.floor(milliseconds / 60000);
    const seconds = Math.floor((milliseconds % 60000) / 1000);
    return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  };


  handleChangeEvent = (event) => {
    const { name, value, type, id, checked } = event.target;
    const { playerData } = this.state;
    const { email } = playerData;

    if (name === "pin" && value.toString().length > 0 && !/^[1-9]\d*$/.test(value)) {
      return;
    }

    if (name === "email" && email !== value) {
      this.setState({
        emailVerified: false,
        isOtpSending: false,
        otp: "",
        showOtp: false,
      });
    }

    if (value?.length > 0 && name === "confirmPassword" && playerData.password !== value) {
      const error = { confirmPassword: playerValidationMessage["confirmPassword"] };
      this.setState({
        playerData: {
          ...playerData,
          [name]: value,
        },
        error,
      });
    } else {
      this.setState({
        playerData: {
          ...playerData,
          [name]: type === "checkbox" ? checked : value?.trim(),
        },
        error: {},
      });
    }
  }

  handleOTP = (event) => {
    const target = event.target;
    let value = target.value?.trim();
    if (value.toString().length > 0 && (!(/^[1-9]\d*$/.test(value))) || value.toString().length > 6) {
      return;
    }
    this.setState({
      otp: value,
      error: {}
    }, () => {
      if (value.toString().length === 6) {
        this.otpVerification();
      }
    });
  }


  otpVerification = async () => {
    try {
      const { otp, playerData } = this.state;
      await this.props.dispatch(otpVerification(playerData.email, otp))
      if (this.props.apiLoginReducer.otpVeirficationSuccess) {
        this.setState({ emailVerified: true })
        this.resetTimer();
      } else if (this.props.apiLoginReducer.otpVeirficationError) {
        let res = this.props.apiLoginReducer.otpVeirficationError;
        this.setState({ error: { "otp": res?.message } });
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  checkError = () => {
    let emailRegex = CONSTANT.emailRegex;
    let regex = /^[0-9]{4,6}$/;
    let checkData = this.state.playerData;
    const stateKeyList = Object.keys(playerValidationMessage);
    for (let i = 0; i < stateKeyList.length; i++) {
      if (!checkData[stateKeyList[i]]) {
        let error = { [stateKeyList[i]]: playerValidationMessage[stateKeyList[i]] }
        this.setState({ error: error })
        return false
      }
      else if (stateKeyList[i] === "email" && !emailRegex.test(checkData[stateKeyList[i]])) {
        let error = { [stateKeyList[i]]: playerValidationMessage[stateKeyList[i]] }
        this.setState({ error: error })
        return false
      }
      else if (stateKeyList[i] === "email" && !this.state.emailVerified && this.state.showOtp) {
        let error = { "otp": "Please enter a valid otp." }
        this.setState({ error: error })
        return false
      }
      else if (stateKeyList[i] === "email" && !this.state.emailVerified) {
        let error = { [stateKeyList[i]]: "Please verify your email address." }
        this.setState({ error: error })
        return false
      }
      else if (stateKeyList[i] === "password" && CONSTANT.STRONG_PASSWORD !== this.passwordType) {
        this.setState({ error: {} })
        let error = { [stateKeyList[i]]: playerValidationMessage[stateKeyList[i]] }
        this.setState({ error: error })
        return false
      } else if (stateKeyList[i] === "confirmPassword" && checkData.password != checkData.confirmPassword) {
        let error = { [stateKeyList[i]]: playerValidationMessage[stateKeyList[i]] }
        this.setState({ error: error })
        return false
      } else if (stateKeyList[i] === "pin" && !regex.test(checkData[stateKeyList[i]])) {
        let error = { [stateKeyList[i]]: playerValidationMessage[stateKeyList[i]] }
        this.setState({ error: error })
        return false
      } else if (stateKeyList[i] === "isEulaAccepted" && !this.state.playerData.isEulaAccepted) {
        let error = { [stateKeyList[i]]: playerValidationMessage[stateKeyList[i]] }
        this.setState({ error: error })
        return false
      }
    }
    return true;

  }
  handleSubmitForm = async () => {
    if (this.checkError()) {
      await this.props.dispatch(addPlayerRegistration(this.state.playerData));
      // this.clearSelectedValues();
    } 
  }
  passwordStrengthListener = passwordTypes => {
    this.passwordType = passwordTypes;
  };
  handleCancel = () => {
    this.setState({
      playerData: playerInitialValue,
      showOtp: false,
      isOtpSending: false,
      error: {}
    })
    this.clearSelectedValues();
    this.resetTimer();
  }


  clearSelectedValues = () => {
    if (this.multiselectRef.current) {
      this.multiselectRef.current.resetSelectedValues();
    }
  };

  onPlayerAddedSuccess = () => {
    this.handleCancel();
    $("#success_popup").modal('hide');
    $("#registerAsPlayer").modal('hide');
    this.props.dispatch(resetFormData());
    res = ''
  }
  hideShowPassword = () => {
    this.setState({
      hidden: !this.state.hidden
    })
  }


  onselect = (selectedList, selectedItem) => {
    this.setClubIdIntoState(selectedList)
  }

  setClubIdIntoState = (clubListObjectArray) => {
    const clubListId = clubListObjectArray.map(clubList => clubList.clubId)
    const { playerData } = this.state;
    this.setState({
      playerData: {
        ...playerData,
        clubs: clubListId,
      },
      error: {}
    })
  }

  onremove = (selectedList, removedItem) => {
    this.setClubIdIntoState(selectedList)
    setTimeout(() => {
      let ele = document.getElementById('multiselectContainerReact');
      document.querySelector('._3vLmCG3bB3CM2hhAiQX1tN, ._1YkOwrSkIvJIAvNNRNP3P5').style.bottom = (ele.offsetHeight + 5) + 'px'
    }, 100);
  }

  handleEmailVerification = async () => {
    const { playerData } = this.state;
    this.setState({ error: {}, otp: "" })
    let emailRegex = CONSTANT.emailRegex;
    let checkData = this.state.playerData;
    if (playerData.email?.length > 0) {
      if (!emailRegex.test(checkData["email"])) {
        let error = { "email": playerValidationMessage["email"] }
        this.setState({ error: error })
        return false
      } else {
        this.setState({ isOtpSending: true, isResendOtp: false })
        let payload = {
          "email": playerData.email
        }
        await this.props.dispatch(emailVerification(payload))
        if (this.props.apiLoginReducer.emailVeirficationSuccess) {
          this.setState({ showOtp: true, isOtpSending: false });
          this.resetTimer();
          this.startTimer();
        } else if (this.props.apiLoginReducer.emailVeirficationError) {
          let res = this.props.apiLoginReducer.emailVeirficationError;
          let msg = res.message;
          this.setState({ error: { "email": msg }, isOtpSending: false });
          return false
        }
      }
    } else {
      let error = { "email": playerValidationMessage["email"] }
      this.setState({ error: error })
      return false
    }
  }

  compareClubList = (allClubList, selectedClubs) => {
    let selectedClubList;
    if (selectedClubs && selectedClubs.length > 0 && selectedClubs[0].hasOwnProperty('clubId')) {
      selectedClubList = allClubList.filter(el => {
        return selectedClubs.find(element => {
          return element.clubId === el.clubId;
        });
      });
    } else {
      selectedClubList = allClubList.filter(el => {
        return selectedClubs.find(element => {
          return element === el.clubId;
        });
      });
    }
    return selectedClubList;
  }



  render() {
    const { playerData, error, clubs, otp } = this.state;
    const { timeRemaining } = this.state;
    const apiSuccess = get(
      this.props,
      "apiRegistrationData.memberRegisterSuccess",
      false
    );
    if (apiSuccess) {
      res = apiSuccess.message
      $('#success_popup').modal('show')
    }
    let countryArray = this.props.countryData;

    let clubNameList = this.state.clubListData?.clubs;
    if (clubNameList && clubNameList.length > 0) {
      var options;
      var clubNameInUpdate = []
      if (clubNameList.length > 0) {
        options = < Multiselect
          options={clubNameList}
          displayValue="name"
          showCheckbox={true}
          groupBy=""
          selectedValues={clubNameInUpdate}
          onSelect={this.onselect} // Function will trigger on select event
          onRemove={this.onremove}
          ref={this.multiselectRef} // Function will trigger on remove event
        />
        setTimeout(() => {
          let ele = document.querySelectorAll('.optionContainer li')
          Object.keys(ele).map((key, idx) => {
            let createEle = document.createElement('span')
            ele[key].appendChild(createEle)
          })
        }, 1000);

      }
    }

    return (
      <React.Fragment>
        <div className="register-as-player b_g_color">
          <button type="button" className="close popup-close-btn" data-dismiss="modal" aria-label="Close" onClick={this.handleCancel}>
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
              <path d="M5.314 6.829l5.671 5.671-5.671 5.67a1.071 1.071 0 001.515 1.515l5.671-5.67 5.671 5.671a1.071 1.071 0 001.515-1.515L14.015 12.5l5.671-5.671a1.071 1.071 0 00-1.516-1.515l-5.67 5.671-5.671-5.671a1.071 1.071 0 00-1.515 1.515z" transform="translate(-5 -5)" fill="#666" />
            </svg>
          </button>
          <div className="text-center pl-32 pt-10">
            <svg
              className="logo mb-3"
              width="136"
              height="51"
              viewBox="0 0 136 51"
            >
              <defs>
                <radialGradient
                  id="prefix__radial-gradient"
                  cx=".5"
                  cy=".5"
                  r=".728"
                  gradientTransform="matrix(.566 .824 -.794 .545 .615 -.185)"
                  gradientUnits="objectBoundingBox"
                >
                  <stop offset="0" stopColor="#1d7439" />
                  <stop offset="1" stopColor="#2d3c25" />
                </radialGradient>
                <radialGradient
                  id="prefix__radial-gradient-2"
                  cx=".5"
                  cy=".5"
                  r=".44"
                  gradientUnits="objectBoundingBox"
                >
                  <stop offset="0" stopColor="#f24e4e" />
                  <stop offset="1" stopColor="#b52830" />
                </radialGradient>
                <radialGradient
                  id="prefix__radial-gradient-4"
                  cx=".69"
                  cy=".389"
                  r=".534"
                  gradientTransform="matrix(.937 0 0 .936 .043 .025)"
                  gradientUnits="objectBoundingBox"
                >
                  <stop offset="0" stopColor="#ffa3a3" />
                  <stop offset=".322" stopColor="#f25151" />
                  <stop offset="1" stopColor="#e60000" />
                </radialGradient>
                <radialGradient
                  id="prefix__radial-gradient-5"
                  cx=".69"
                  cy=".37"
                  r=".503"
                  gradientTransform="matrix(.995 0 0 .936 .003 .024)"
                  href="#prefix__radial-gradient-4"
                />
                <linearGradient
                  id="prefix__linear-gradient"
                  x1=".068"
                  x2=".97"
                  y1=".106"
                  y2=".938"
                  gradientUnits="objectBoundingBox"
                >
                  <stop offset="0" stopColor="#124e25" />
                  <stop offset="1" stopColor="#e60000" />
                </linearGradient>
                <filter
                  id="prefix__Path_5390"
                  width="83.263"
                  height="60.093"
                  x="0"
                  y="0"
                  filterUnits="userSpaceOnUse"
                >
                  <feOffset />
                  <feGaussianBlur result="blur" stdDeviation="6" />
                  <feFlood floodColor="#fff" floodOpacity=".584" />
                  <feComposite in2="blur" operator="in" />
                  <feComposite in="SourceGraphic" />
                </filter>
              </defs>
              <g id="prefix__logo" transform="translate(770 -8592)">
                <g
                  id="prefix__Layer_x0020_1"
                  transform="translate(-717.904 8595.254)"
                >
                  <g id="prefix___1995880576128">
                    <path
                      id="prefix__Path_5387"
                      fill="#b52830"
                      fillRule="evenodd"
                      d="M1474.247 318.928a3.914 3.914 0 0 0 3.235-1.562l1.711 1.748a6.462 6.462 0 0 1-9.371.558 5.806 5.806 0 0 1-1.822-4.425 6.085 6.085 0 0 1 1.822-4.462 6.543 6.543 0 0 1 9.445.483l-1.673 1.859a3.874 3.874 0 0 0-3.161-1.562 3.728 3.728 0 0 0-2.566.967 3.4 3.4 0 0 0-1.078 2.677 3.767 3.767 0 0 0 1 2.715 3.338 3.338 0 0 0 2.458 1.004zm71.544-9.668a6.848 6.848 0 0 1 4.908 1.6 5.575 5.575 0 0 1 1.748 4.351 5.916 5.916 0 0 1-1.674 4.462 7.141 7.141 0 0 1-5.132 1.636h-4.127V309.26zm.111 9.668a3.869 3.869 0 0 0 2.826-.93 4.171 4.171 0 0 0 0-5.429 4.123 4.123 0 0 0-3.012-.967h-1.487v7.326zm-20.006-.744a2.329 2.329 0 0 0 3.607 0 3.734 3.734 0 0 0 .632-2.268v-6.656h2.715v6.731a5.314 5.314 0 0 1-1.45 4.016 5.551 5.551 0 0 1-7.4 0 5.194 5.194 0 0 1-1.487-4.016v-6.731h2.715v6.656a3.508 3.508 0 0 0 .672 2.269zm-14.096-2.974a4.083 4.083 0 0 0-1.041-2.752 3.33 3.33 0 0 0-2.529-1.116 3.408 3.408 0 0 0-2.566 1.116 4.05 4.05 0 0 0-1 2.752 3.984 3.984 0 0 0 1 2.752 3.408 3.408 0 0 0 2.566 1.116 3.331 3.331 0 0 0 2.529-1.116 4.015 4.015 0 0 0 1.041-2.752zm.892 4.425a6.2 6.2 0 0 1-4.5 1.785 6.113 6.113 0 0 1-4.462-1.785 6.284 6.284 0 0 1 0-8.85 6.113 6.113 0 0 1 4.47-1.785 6.2 6.2 0 0 1 4.5 1.785 6.284 6.284 0 0 1 0 8.85zm-25.472 1.673V309.26h2.677v9.631h5.131v2.417z"
                      data-name="Path 5387"
                      transform="translate(-1468 -309)"
                    />
                  </g>
                </g>
                <g
                  id="prefix__Layer_x0020_1-2"
                  data-name="Layer_x0020_1"
                  transform="translate(-687.151 8610.574)"
                >
                  <g id="prefix___1995880576128-2" data-name="_1995880576128">
                    <path
                      id="prefix__Path_5387-2"
                      fill="#124e25"
                      fillRule="evenodd"
                      d="M2468.883 761.043c-.967-.186-1.9-.335-2.789-.521v6.991c-1.748-.409-3.458-.818-5.169-1.227v-25.137c2.789 0 5.541 0 8.33.037a7.253 7.253 0 0 1 4.276 1.264 8.455 8.455 0 0 1 2.789 3.793 15.2 15.2 0 0 1 1 5.764 14.442 14.442 0 0 1-.929 5.392 6.531 6.531 0 0 1-2.64 3.2c.632 1.6 1.339 3.235 1.971 4.871s1.3 3.31 1.971 5.02c-1.859-.483-3.681-.967-5.5-1.413-.558-1.376-1.116-2.752-1.673-4.09s-1.12-2.643-1.637-3.944zm3.235-9.557a5.146 5.146 0 0 0-.818-3.086 2.988 2.988 0 0 0-2.38-1.19c-.93-.074-1.9-.112-2.826-.186v7.735c.93.112 1.9.26 2.826.372a2.457 2.457 0 0 0 2.38-.744 4.29 4.29 0 0 0 .818-2.901zm-14.019 8.776v5.392c-4.871-1.078-9.742-2.082-14.577-3.012v-21.568c4.722 0 9.482.037 14.242.037v5.355c-3.086-.149-6.135-.335-9.148-.483v3.83l8.032.669v5.132c-2.677-.372-5.355-.707-8.032-1.041v4.09c3.124.521 6.322 1.078 9.484 1.599zm-27.108-6.731c-.632.707-1.264 1.376-1.9 2.045v4.871c-1.71-.223-3.384-.409-5.094-.558V741h5.094v8.106c1.153-1.3 2.343-2.6 3.5-3.942 1.19-1.339 2.343-2.752 3.533-4.128h5.652c-1.227 1.562-2.491 3.086-3.719 4.574s-2.491 2.9-3.719 4.313q1.953 2.956 3.9 6.024c1.3 2.082 2.6 4.239 3.9 6.433-1.97-.335-3.979-.669-5.95-.967-.892-1.376-1.748-2.715-2.6-4.016s-1.705-2.597-2.597-3.866z"
                      data-name="Path 5387"
                      transform="translate(-2424 -741)"
                    />
                  </g>
                </g>
                <g
                  id="prefix__Layer_x0020_1-3"
                  data-name="Layer_x0020_1"
                  transform="translate(-716.899 8631.36)"
                >
                  <g id="prefix___1995880576128-3" data-name="_1995880576128">
                    <path
                      id="prefix__Path_5387-3"
                      d="M1632.2 1411l.743 2.305h2.417l-1.971 1.413.744 2.305-1.934-1.413-1.971 1.413.744-2.305-1.971-1.413h2.417z"
                      fillRule="evenodd"
                      fill="url(#prefix__radial-gradient)"
                      data-name="Path 5387"
                      transform="translate(-1629 -1406.479)"
                    />
                    <path
                      id="prefix__Path_5393"
                      fill="url(#prefix__radial-gradient-2)"
                      fillRule="evenodd"
                      d="M1905.541 1287l1.339 4.053h4.239l-3.458 2.491 1.339 4.056-3.458-2.529-3.421 2.529 1.3-4.053-3.421-2.491h4.239z"
                      data-name="Path 5393"
                      transform="translate(-1889.737 -1287)"
                    />
                    <path
                      id="prefix__Path_5394"
                      d="M2323.16 1411l.744 2.305h2.454l-1.971 1.413.743 2.305-1.971-1.413-1.971 1.413.781-2.305-1.97-1.413h2.417z"
                      fillRule="evenodd"
                      fill="url(#prefix__radial-gradient)"
                      data-name="Path 5394"
                      transform="translate(-2294.305 -1406.479)"
                    />
                  </g>
                </g>
                <g
                  id="prefix__Layer_x0020_1-4"
                  data-name="Layer_x0020_1"
                  transform="translate(-770 8610.574)"
                >
                  <g id="prefix___1995880576128-4" data-name="_1995880576128">
                    <path
                      id="prefix__Path_5387-4"
                      fill="#2d3c25"
                      fillRule="evenodd"
                      d="M231.326 731.409v21.01c-1.413.26-2.789.484-4.2.744-1.339-1.673-2.715-3.421-4.016-5.206-1.339-1.822-2.677-3.718-4.016-5.615v12.383c-1.673.372-3.347.706-5.02 1.078v-24.32h4.239c1.3 2.045 2.64 4.053 3.979 5.987 1.3 1.934 2.677 3.793 4.016 5.615v-11.639c1.671 0 3.345-.037 5.018-.037zm-27.666 27.22a11.91 11.91 0 0 1-4.276.149 7.285 7.285 0 0 1-3.384-1.525c.558-2.082 1.153-4.128 1.711-6.136a7.631 7.631 0 0 0 2.826 1.487 7.024 7.024 0 0 0 3.161.149c1.971-.335 2.938-1.227 2.938-2.64a1.583 1.583 0 0 0-.818-1.525 12.094 12.094 0 0 0-2.715-.744 16.268 16.268 0 0 1-3.458-.967 5.237 5.237 0 0 1-2.343-2.194 8.661 8.661 0 0 1-.967-4.537 11.956 11.956 0 0 1 .892-4.685 6.934 6.934 0 0 1 2.715-3.272 7.641 7.641 0 0 1 4.425-1.19 11.5 11.5 0 0 1 3.533.558 9.626 9.626 0 0 1 3.049 1.636c-.521 1.748-1.078 3.533-1.6 5.318a8.179 8.179 0 0 0-5.02-1.71 3.4 3.4 0 0 0-2.231.781 2.564 2.564 0 0 0-.706 1.785 1.631 1.631 0 0 0 .855 1.562 8.906 8.906 0 0 0 2.64.892 20.814 20.814 0 0 1 3.458 1 5.675 5.675 0 0 1 2.343 2.008 6.686 6.686 0 0 1 1 3.979 10.151 10.151 0 0 1-.892 4.2 9.793 9.793 0 0 1-2.715 3.5 10.669 10.669 0 0 1-4.421 2.121z"
                      data-name="Path 5387"
                      transform="translate(-196 -731)"
                    />
                  </g>
                </g>
                <path
                  id="prefix__Path_5391"
                  fill="url(#prefix__radial-gradient-4)"
                  d="M1815.077 749.89a11.256 11.256 0 0 1-5.169-1.19 8.624 8.624 0 0 1-3.607-3.309 7.207 7.207 0 0 1-.967-2.268 10.144 10.144 0 0 1 0-5.169 8.008 8.008 0 0 1 .967-2.343 9.044 9.044 0 0 1 3.607-3.384 11.5 11.5 0 0 1 10.337 0 9.393 9.393 0 0 1 4.611 5.838 11.7 11.7 0 0 1 0 5.243 8.272 8.272 0 0 1-1 2.268 8.783 8.783 0 0 1-3.607 3.272 11.093 11.093 0 0 1-5.172 1.042z"
                  data-name="Path 5391"
                  transform="translate(-2515.169 7879.574)"
                />
                <path
                  id="prefix__Path_5392"
                  fill="url(#prefix__radial-gradient-5)"
                  d="M1229.077 750.968a9.508 9.508 0 0 1-5.169-.669 7.864 7.864 0 0 1-3.607-3.272 8.9 8.9 0 0 1-.967-2.454 11.859 11.859 0 0 1-.334-2.863 12.486 12.486 0 0 1 .334-2.938 11.263 11.263 0 0 1 .967-2.64 9.841 9.841 0 0 1 3.607-3.793 10.1 10.1 0 0 1 5.169-1.339 10.336 10.336 0 0 1 5.169 1.264 9.132 9.132 0 0 1 3.607 3.421 8.506 8.506 0 0 1 1 2.305 11.621 11.621 0 0 1 .3 2.6 11.878 11.878 0 0 1-.3 2.6 9.282 9.282 0 0 1-1 2.343 10.066 10.066 0 0 1-3.607 3.681 11.556 11.556 0 0 1-5.169 1.754z"
                  data-name="Path 5392"
                  transform="translate(-1950.96 7879.574)"
                />
                <g
                  filter="url(#prefix__Path_5390)"
                  transform="translate(-783.88 8573)"
                >
                  <path
                    id="prefix__Path_5390-2"
                    fill="url(#prefix__linear-gradient)"
                    fillRule="evenodd"
                    d="M311.715 209.255a3.839 3.839 0 0 1 2.677-1.859c-.149-.149-.3-.186-.446-.335a.556.556 0 0 0-.26-.112l-2.12-1.339c-.335-.149-.595-.372-.93-.521a2.356 2.356 0 0 1-.26-.074l-.781-.335c-.446-.186-.707-.074-1.153.26a5.669 5.669 0 0 0-.818.818 14.324 14.324 0 0 0-.595 3.384 26.652 26.652 0 0 0 .335 5.169 7.188 7.188 0 0 1-.037 1.264c-.074.707 0 .558.446.967-.149-.037 0 0-.112-.037-.335-.074-.335 0-.3.3a1.244 1.244 0 0 1-.223.707 9.5 9.5 0 0 0-.186 1c-.074.781-.6 1.673.037 1.9.074.483.112.558.558.558a1.411 1.411 0 0 0 .781.818 1.77 1.77 0 0 1 .521.186 1.08 1.08 0 0 0 .521.112l-.372-.446c.149.186 1.078 1.041 1.562.521-.074-.521-.855-.892-.632-1.413.112-.3.669-.521.855-1.078.223.149.149.558 1.116.446a3.655 3.655 0 0 1-.186-.6c0-.223.074-.26-.037-.521a8.512 8.512 0 0 0-.521-1c-.483-.855-.93-.632-1.748-.149l.112-.149a1.682 1.682 0 0 1 .93-.446c-1.153-3.049.372-5.727.26-6.433a.693.693 0 0 0-.335-.446c-.335-.26-.707-.706-1.19-.706 0-.037 0-.037.037-.074.186-.149.409-.037.558.037.521.335.967.818 1.45 1.19a1.148 1.148 0 0 0 .037-.372 3.85 3.85 0 0 1 .149-.372c0 .632-.186 1.487.372 1.934a1.8 1.8 0 0 1 .669.632 8.812 8.812 0 0 0 1.264 1.376 22.273 22.273 0 0 0 2.008 1.785 6.915 6.915 0 0 1-.112-1.748 2.785 2.785 0 0 1 .409-1.45 7.8 7.8 0 0 0-.223 1.9c.074 2.008.707 1.934 1.971 3.124.409.409.892.818 1.3 1.19a8.507 8.507 0 0 0 2.863 2.008c.669.186 3.458.669 3.533.707-.446 0-1.525-.149-2.045-.186l-6.1-.595c-1.339-.112-2.715-.3-4.09-.372-.669-.037-1.339-.112-2.045-.186-.632-.074-.446-.074-.855.335-.149.149-.26.149-.26.372a1.466 1.466 0 0 0 .186.521c.595.074 3.719.3 4.388.335l13.2 1c2.938.223 5.838.446 8.813.669.483.037 3.979.26 4.351.335.409.112.744.521 1.078.706a23.932 23.932 0 0 0 2.38 1.339 2.078 2.078 0 0 1-.037-.818l.149.558.037-.074c.037-.037.037-.037.037-.074a3.042 3.042 0 0 0 .446-.744.51.51 0 0 0-.223-.483c-.149-.074-2.343-.372-2.6-.409l2.491.186c-.223-.521.149-.669.335-.632-.558.26-.186.595.037 1.041.335.632-.335.93-.483 1.413a1.417 1.417 0 0 0-.037.558.739.739 0 0 0 .707.744 1.535 1.535 0 0 0 .26-.409 4.951 4.951 0 0 1-.558 1.19c-.409.818.112.93.558.781.595-.26.707-.892.967-1.339a5.865 5.865 0 0 0 .409-.855 1.047 1.047 0 0 1-.781-.372l.112.074a1.28 1.28 0 0 0 .744.149 2.849 2.849 0 0 0 .149-1 1.247 1.247 0 0 1 0-.372 1.6 1.6 0 0 1 .149.521.614.614 0 0 1 .446 0c.037.335-.186 1.19-.112 1.748.074.892.409 1.227 1.153.669a2.456 2.456 0 0 1 0-1.711c.037-.223.037-.372.074-.595.409-.186.669.112.93.335.3.3.632.26.855.521.335.409.335.483.892.483.409-.037.967-.186.781-.632-.446-.223-.632.074-1.078-.446a4.7 4.7 0 0 1 .669.223 3.87 3.87 0 0 0 1.19-.037c.409 0 .93 0 .781-.595h-.26a4.018 4.018 0 0 1-1.487-.223c-.26-.037-.558-.074-.855-.112a2.275 2.275 0 0 0-.781-.223 1.066 1.066 0 0 0 .223.409 1.9 1.9 0 0 1-.446-.483c-.186-.186-.26-.3-.521-.335-.186-.037-.558-.112-.707 0-.112.112-.149.372-.223.521l-.037.037c-.037-.223.037-.372-.074-.595a1.408 1.408 0 0 0-.967-.037c-.186.223-.074.409-.149.669-.149-.446.112-.818-.558-.818l-.149.223c-.335-.446-.669.558-.744.744-.112.335-.409.707-.483 1l.335-1a1.621 1.621 0 0 1 .149-.26c.483-.744.112-.781-.26-1.3h.037l.037.037c.037 0 .037 0 .037.037l.186.149a.586.586 0 0 0 .26.26c.186.037 1.934.112 2.194.149.632.037 2.529.223 3.012.186-.074-.26-.112-.372.037-.521a.743.743 0 0 0 .074.483c.446.372.892-.483.372-.744-.372-.149-3.272-.074-3.9-.26h.558c-.3-.409-.669.037-1.116-.112-.26-.112-.074-.223-.483-.149a1.542 1.542 0 0 0-.595.112l-17.254-1.413c.93-.112 2.715.186 3.793-.521a4.24 4.24 0 0 0 .855-.744 6.987 6.987 0 0 1-1.785-.112 2.2 2.2 0 0 1-1.413-.744 2.649 2.649 0 0 0 1.376.483 8.017 8.017 0 0 0 1.636 0 3 3 0 0 1 .037-1 1.732 1.732 0 0 1 .223-.744c.037-.112 0-.037.074-.112-.074.335-.409 1.339-.112 1.748a3.608 3.608 0 0 0 1.487.632c-.112-.409-.372-.669-.149-1.227a2.557 2.557 0 0 0 .112.892c.149.335.335.372.595.521l.632.335a6.011 6.011 0 0 1 .669.372 6.206 6.206 0 0 1 .595.446 3.4 3.4 0 0 0 2.194.632c1.413.074 5.429.483 6.582.372a16.282 16.282 0 0 0-3.2-3.384 1.679 1.679 0 0 0-1.487-.335 1.285 1.285 0 0 1-.781-.149 22.24 22.24 0 0 1-1.748-1.413 2.325 2.325 0 0 0-1.227-.781 2.71 2.71 0 0 0-1.673.521c.446-.3.595-.558 1.264-.632a1.526 1.526 0 0 1 1.116.26 1.465 1.465 0 0 0-.93-.632c-1.6-.521-2.454 1.153-3.012 1.636l.037-.074a4.806 4.806 0 0 1 1.264-1.339c.892-.669 1.078-.446 1.971-.26a3.507 3.507 0 0 0-.372-.372l-.335-.446a13.52 13.52 0 0 0-2.194-2.008c-.223.335-.149.3-.632.483-1.822.669-2.194.595-3.309 2.268-.26.372-.409.93-.595 1.227.037-.074.037-.186.074-.3l.632-1.3.632-.855c.446-.521.632-.521 1.376-.818.595-.26 1.227-.3 1.525-.744-.112-.335-.3-.3-.446-.446a3.4 3.4 0 0 0-.483-.3 3.717 3.717 0 0 1-.521-.3c-.149-.074-.372-.149-.558-.223-.595-.223-1.785-.669-2.268.26a3.016 3.016 0 0 0-.223 1.227c0 .446.037.855 0 1.3a5.114 5.114 0 0 1-.744 2.268l.037-.186a5.492 5.492 0 0 0 .409-2.566c-.26.186-.372.446-.744.521a4.469 4.469 0 0 0 .707-.781c.3-.446.186-.632.112-1.116-.037-.521-.037-2.231-.074-2.454-.074.149-.074.26-.149.409l-.335.744a1.745 1.745 0 0 1-.223.335 2.681 2.681 0 0 1-1.487 1 2.893 2.893 0 0 0 1.748-1.822 4.671 4.671 0 0 0 .112-2.6 3.772 3.772 0 0 0-2.6-2.715 5.125 5.125 0 0 0-5.95 2.082 4.75 4.75 0 0 0-.521 2.417 4.418 4.418 0 0 0 .483 2.194c.112.112.335.409.372.446-.112-.037-.3-.186-.521-.112-.558.186-.409 1.19-.3 1.636a2.407 2.407 0 0 0 .595 1.19c.335.26.595-.149 1.153.037a6.226 6.226 0 0 0 .707 1.934 1.461 1.461 0 0 0 .558.669c.632.483 1.6 1.6 1.748 1.71a3.072 3.072 0 0 0 1.562.483 2.194 2.194 0 0 1-1.711-.483 5.532 5.532 0 0 0-1.19-.892c-.112-.074-.112-.037-.186-.112-.223-.149-.483-.3-.707-.446a4.566 4.566 0 0 1-1.487-.855c-.223-.186-.372-.483-.558-.669a6.647 6.647 0 0 1 .074 1.45 7.384 7.384 0 0 0-.744-.781c-.26-.223-.521-.521-.892-.521a6.859 6.859 0 0 1 .26-3.049 7.386 7.386 0 0 0-.112 2.863c.186.074.149 0 .372.186s.781.744.967.855a9.414 9.414 0 0 0-.112-1.413c.558.483.93 1.227 1.636 1.45a4.618 4.618 0 0 1 1.116.595 6.15 6.15 0 0 1-1.078-1.525 8.584 8.584 0 0 0-.372-1.041c-.223-.372-.521-.037-.855-.186a2.26 2.26 0 0 1-.93-1.636 2.292 2.292 0 0 1-.037-1c.074-.521.149-.372.409-.707a8 8 0 0 1-.483-2.231c-.037-.558.186-1.748 0-1.934-.409-.3-1.673.558-1.971.818a5.07 5.07 0 0 0-1.153 1.45c.149-.26.26-.558.446-.855a4.129 4.129 0 0 1 1.264-1.153.515.515 0 0 0-.409-.446c-.335-.112-.409.112-.6.223-.186-.037-.372-.149-.595.037a5.516 5.516 0 0 0-1.078 1.376c.112-.223.26-.483.409-.781.112-.186.409-.595.335-.855-.223-.223-.223-.074-.446-.074-.149-.037-.223-.186-.446-.149-.93.037-1.413 1.9-1.376 2.194a2 2 0 0 1 .186-1.264c.149-.3.558-.818.632-1.041a3.772 3.772 0 0 0-.967-.595.653.653 0 0 0-.6-.074 3.838 3.838 0 0 0-2.63 1.669z"
                    data-name="Path 5390"
                    transform="translate(-288.68 -186.59)"
                  />
                </g>
              </g>
            </svg></div>
          <form className="add-player-wrapper pt-10">
            <div className="position-relative">
              <h3 className="mb-3 d-flex justify-content-center">Registration Form</h3>
            </div>
            <div className="add-player-inner mb-3">
              <div className="row">
                <div className="col-lg-4 col-md-4 pr-lg-2">
                  <div className="form-group">
                    <label>
                      First Name <sup className="star">*</sup>
                    </label>
                    <div className="position-relative">
                      <input
                        className={`form-control ${error?.firstName ? 'input-error' : ''}`}
                        type="text"
                        placeholder="Enter first name"
                        name="firstName"
                        value={playerData.firstName}
                        onChange={this.handleChangeEvent}
                        onKeyPress={(e) => UtilService.alphabetsValidation(e)}
                        onPaste={(e) => UtilService.onPastRestriction(e)}
                      />
                      <ValidationMessage message={error?.firstName} />
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 pr-lg-2">
                  <div className="form-group">
                    <label>Middle Name</label>
                    <div className="position-relative">
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Enter middle name"
                        name="middleName"
                        value={playerData.middleName}
                        onChange={this.handleChangeEvent}
                        onKeyPress={(e) => UtilService.alphabetsValidation(e)}
                        onPaste={(e) => UtilService.onPastRestriction(e)}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4">
                  <div className="form-group">
                    <label>
                      Last Name <sup className="star">*</sup>
                    </label>
                    <div className="position-relative">
                      <input
                        className={`form-control ${error?.lastName ? 'input-error' : ''}`}
                        type="text"
                        placeholder="Enter last name"
                        name="lastName"
                        value={playerData.lastName}
                        onChange={this.handleChangeEvent}
                        onKeyPress={(e) => UtilService.alphabetsValidation(e)}
                        onPaste={(e) => UtilService.onPastRestriction(e)}
                      />
                      <ValidationMessage message={error?.lastName} />
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 pr-lg-2">
                  <div className="form-group">
                    <label>
                      Email Address <sup className="star">*</sup>
                      <i className="fa fa-info-circle info_icon" aria-hidden="true">
                        <span className="tooltiptext">If you modify your email address in any way after it has been verified, you must re-verify it.</span>
                      </i>
                    </label>
                    <div className="position-relative">
                      <input
                        autoComplete="new-password"
                        className={`form-control ${error?.email ? 'input-error' : ''}`}
                        type="text"
                        placeholder="Enter email"
                        name="email"
                        value={playerData.email}
                        onChange={this.handleChangeEvent}

                      />
                      <ValidationMessage message={error?.email} />
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 pr-lg-2 ">

                  <div className="form-group email-condition">
                    <label>
                    </label>
                    <div className="position-relative">
                      {
                        this.state.showOtp ?
                          this.state.emailVerified ?
                            (<div className="alert alert-success d-flex align-items-center" role="alert">
                              <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><style>{`svg{fill:#0f3918}`}</style><path d="M256 0c36.8 0 68.8 20.7 84.9 51.1C373.8 41 411 49 437 75s34 63.3 23.9 96.1C491.3 187.2 512 219.2 512 256s-20.7 68.8-51.1 84.9C471 373.8 463 411 437 437s-63.3 34-96.1 23.9C324.8 491.3 292.8 512 256 512s-68.8-20.7-84.9-51.1C138.2 471 101 463 75 437s-34-63.3-23.9-96.1C20.7 324.8 0 292.8 0 256s20.7-68.8 51.1-84.9C41 138.2 49 101 75 75s63.3-34 96.1-23.9C187.2 20.7 219.2 0 256 0zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z" /></svg>
                              <span className="pl-2"> Email verified! </span>
                            </div>)
                            : (<span className="text-success">
                              We've sent a verification code to this email.
                              <span class="text-danger font-weight-bold pl-2" title={`The OTP will expire in ${this.formatTime(timeRemaining)} minutes.`}> {this.formatTime(timeRemaining)}</span>
                            </span>)
                          :
                          this.state.isOtpSending ?
                            (<div class="spinner-border text-success" role="status">
                              <span class="sr-only">Loading...</span>
                            </div>)
                            :
                            (<button
                              type="button"
                              className={`btn btn-link ${this.state.isResendOtp ? "text-danger" : ""}`}
                              onClick={this.handleEmailVerification}
                            >
                              {this.state.isResendOtp ? "Resend OTP" : "Verify email address"}
                            </button>)
                      }
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 pr-lg-2 ">
                  {
                    this.state.showOtp && !this.state.emailVerified && <div className="form-group">
                      <label>
                        OTP <sup className="star">*</sup>
                      </label>
                      <div className="position-relative">
                        <input
                          className={`form-control ${error?.otp ? 'input-error' : ''}`}
                          type="number"
                          placeholder="One Time Password"
                          name="otp"
                          value={otp}
                          onChange={this.handleOTP}
                          onInput={(e) => {
                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 15)
                          }}
                        />
                        <ValidationMessage message={error?.otp} />
                      </div>
                    </div>
                  }

                </div>

                <div className="col-lg-6 col-md-6 pr-lg-2">
                  <div className="form-group">
                    <label>
                      Contact Number <sup className="star">*</sup>
                    </label>
                    <div className="d-flex mobile-number">
                      <div className="position-relative">
                        <select
                          id="code_select"
                          className="form-control border-none pr-4"
                          name="countryCode"
                          onChange={this.handleChangeEvent}
                        >
                          {countryArray && countryArray?.map((countries, key) =>
                            <option key={key} value={`${countries.countryId},${countries.countryCode}`}> {countries.countryId}({countries.countryCode}) </option>
                          )}

                        </select>
                        <i className="arrow-icon"></i>
                      </div>

                      <div className="position-relative flex-1">
                        <input
                          type="number"
                          className={`form-control border-none pr-4 ${error?.mobile ? 'input-error' : ''}`}
                          placeholder="Enter contact number"
                          name="mobile"
                          value={playerData.mobile}
                          onChange={this.handleChangeEvent}
                          onInput={(e) => {
                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 15)
                          }}
                        />
                        <ValidationMessage message={error?.mobile} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 pr-lg-2">
                  <div className="form-group">
                    <label htmlFor="currencyType">Currency</label>
                    <div className="position-relative">
                      <div className="form-group">
                        <select
                          className="form-control"
                          name="currency"
                          aria-label="Select Currency"
                          id="currencyType"
                          value={playerData.currency}
                          onChange={this.handleChangeEvent}

                        >
                          <option value="">Select</option>
                          {this.state.currenciesData.map((key, idx) => {
                            return (
                              <option key={idx} value={key.currencyCode}>
                                {key.currency}
                              </option>
                            );
                          })}
                        </select>
                        <i className="arrow-icon"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 pr-lg-2">
                  <div className="form-group">
                    <label>
                      Password<sup className="star">*</sup>
                      <i className="fa fa-info-circle info_icon" aria-hidden="true">
                        <span className="tooltiptext">Password must have atleast 8 characters an uppercase letter,
                          a lowercase letter, a number and a special character
                          (!”?$%^&).</span>
                      </i>
                    </label>
                    <div className="position-relative">
                      <PasswordField
                        autoComplete="new-password"
                        className={error?.password ? 'input-error' : ''}
                        name="password"
                        value={playerData.password}
                        placeholder="Enter password"
                        handleChangeEvent={this.handleChangeEvent}
                      />
                      <ValidationMessage message={error?.password} />

                    </div>
                    {!error?.password?.length > 0 && <PasswordStrengthView
                      passwordValue={playerData.password}
                      passwordStrengthListener={this.passwordStrengthListener}
                    />}
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 pr-lg-2">
                  <div className="form-group">
                    <label>
                      Confirm Password<sup className="star">*</sup>
                    </label>
                    <div className="position-relative">
                      <PasswordField
                        autoComplete="new-password"
                        className={error?.confirmPassword ? 'input-error' : ''}
                        name="confirmPassword"
                        value={playerData.confirmPassword}
                        placeholder="Enter confirm password"
                        handleChangeEvent={this.handleChangeEvent}
                      />
                      <ValidationMessage message={error?.confirmPassword} />

                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 pr-lg-2">
                  <div className="form-group">
                    <label>
                      User Pin<sup className="star">*</sup>
                      <i className="fa fa-info-circle info_icon" aria-hidden="true">
                        <span className="tooltiptext">User PIN must have 4-6 numeric value. This user PIN will be used while playing the game and purchasing of the food and beverages items" </span>
                      </i>
                    </label>
                    <div className="position-relative">
                      <input
                        maxLength="6"
                        minLength="4"
                        className={`form-control ${error?.pin ? 'input-error' : ''}`}
                        type={this.state.hidden ? "password" : "number"}
                        placeholder="Enter pin"
                        name="pin"
                        value={playerData.pin}
                        onChange={this.handleChangeEvent}

                      />
                      <div>
                        <div
                          onClick={() => {
                            this.hideShowPassword();
                          }}
                        >
                          {playerData.pin.toString().length > 0 && (!this.state.hidden ? <i className="fa fa-eye view-pass" aria-hidden="true"></i>
                            : <i class="fa fa-eye-slash view-pass" aria-hidden="true"></i>)}
                        </div>
                      </div>
                      <ValidationMessage message={error?.pin} />
                    </div>
                  </div>
                </div>

                <div className="col-lg-6 col-md-6 pr-lg-2">
                  <div className="form-group w-100">
                    <label>Club Name</label>
                    <div className="d-flex align-items-center position-relative">
                      <div className="position-relative red-checkbox flex-1">
                        {options}
                        <i className="arrow-icon"></i>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-12 col-md-12">
                  <div className="d-flex align-items-center position-relative checks justify-content-between">
                    <div className="position-relative red-checkbox mr-3 d-flex">
                      <label
                        className="form-check-label position-relative d-flex align-items-center"
                        htmlFor="exampleCheck1"
                      >
                        <input
                          type="checkbox"
                          className="form-check-input checkbox-element"
                          name="isEulaAccepted"
                          checked={playerData.isEulaAccepted}
                          // disabled={this.props.isUpdate ? true : false}
                          onChange={this.handleChangeEvent}
                        />
                        <span className="checkmark mr-2"></span>
                        I Accept End User License Agreement
                      </label>
                      <label
                        className="form-check-label position-relative d-flex align-items-center"
                        htmlFor="exampleCheck1"
                      >
                        <NavLink className="align-items-center" to="/termsConditions" target="_blank" rel="noopener noreferrer">(EULA)</NavLink>
                      </label>
                    </div>
                    <div className="position-relative red-checkbox mr-3 d-flex">
                      <label
                        className="form-check-label position-relative d-flex align-items-center"
                        htmlFor="exampleCheck1"
                      >
                          <input
                            type="checkbox"
                            className="checkbox-element"
                            onChange={this.handleChangeEvent}
                            name="isReferee"
                            ref="complete"
                            checked={playerData.isReferee}
                          />
                          <span className="checkmark mr-3"></span>
                          Is Referee
                      </label>
                      <label
                        className="form-check-label position-relative d-flex align-items-center"
                        htmlFor="exampleCheck1"
                      >                      
                      </label>
                    </div>                    
                    <ValidationMessage message={error?.isEulaAccepted} />
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-center align-items-center">
              {/* <div className="d-flex justify-content-between align-items-center">
          </div>  */}
              <div className="d-flex align-items-center">
                <button
                  type="button"
                  className="btn back-btn cancel-btn"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={this.handleCancel}
                >
                  Cancel
                </button>
                <button type="button" className="btn red-btn" onClick={this.handleSubmitForm}>
                  Register
                </button>
              </div>
            </div>
          </form>
          <div className="modal fade" id="success_popup" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="d-table w-100">
              <div className="d-table-cell">
                <div className="modal-dialog  modal-dialog-centered" role="document">
                  <div className="modal-content">
                    <div className="modal-body p-0 border-0 mb-3">
                      <div>
                        <p className="text-center m-0 text-success robotomedium font-16" dangerouslySetInnerHTML={{ __html: res }} >
                        </p>
                      </div>
                    </div>
                    <div className="modal-footer p-0 border-0 justify-content-center">
                      <button
                        className="btn login-btn pl-4 pr-4 m-0"
                        onClick={() => { this.onPlayerAddedSuccess() }}
                      >
                        OK, Thanks!
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  apiRegistrationData: state.loginReducer,
  apiReducer: state.apiReducer,
  apiLoginReducer: state.loginReducer
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch,
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(registrationPage);
